<div (outsideClick)="onOutsideClick()">
  @if (item) {
  <div
    class="sidebar-item-container"
    (click)="toggleExpand()"
    [hidden]="item.hidden()"
    [class.active]="isActive()"
    [class.expanded]="item.expanded"
    (mouseenter)="isHovered = true"
    (mouseleave)="isHovered = false"
  >
    @if (item.icon) {
    <a360-icon
      class="settings-icon"
      [icon]="item.icon"
      [color]="isActive() || (isHovered && !isMobileDevice) ? iconColors.LIGHT_ORANGE : iconColors.WHITE"
      [isHoverEnable]="!isMobileDevice"
      [text]="!isCollapsed ? item.name : ''"
      [style]="item.style"
    >
    </a360-icon>
    }

    <a360-icon
      class="expand-arrow"
      [class.collapsed]="isCollapsed"
      icon="arrow-to-right"
      [color]="iconColors.LIGHT_GREY"
    ></a360-icon>
  </div>
  }
  <div class="sidebar-item-container-children" [ngClass]="{ active: item.expanded }">
    @for (subItem of subMenuItems; track subItem) {
    <div
      class="sub-item"
      [ngClass]="{ active: subItem.isActive() }"
      [hidden]="subItem.hidden()"
      (click)="onSubItemClick(subItem)"
    >
      {{ subItem.name }}
    </div>
    }
  </div>
</div>
